import React, { useMemo } from "react";

const ViewSalaryDetails = ({ EmpDetails }) => {
  console.log(EmpDetails, "this is staf details");

  const { allowances, deductions } = useMemo(() => {
    const formatted =
      EmpDetails?.employee_salary_extras?.map((item) => ({
        employee_defined_extra_id: item.employee_defined_extra_id,
        value: item.value,
        salary_extra_id: item.employee_defined_extras?.salary_extra_id,
        name: item.employee_defined_extras?.salary_extras?.name,
        is_deduction: item.employee_defined_extras?.salary_extras?.is_deduction,
      })) || [];

    return {
      allowances: formatted.filter((i) => i.is_deduction === 0),
      deductions: formatted.filter((i) => i.is_deduction === 1),
    };
  }, [EmpDetails]);

  console.log(allowances, "allowances");
  console.log(deductions, "deductions");

  const groupByTwo = (arr) => {
    const result = [];
    for (let i = 0; i < arr.length; i += 2) {
      result.push(arr.slice(i, i + 2));
    }
    return result;
  };
  return (
    <>
      <div className="card">
        <h2 style={{ margin: 10 }}>Personal Details</h2>
        <br />
        <div className="col-md-12 d-flex">
          <div className=" d-flex col-md-6 ">
            <div>
              {" "}
              <h5>Name : &ensp;</h5>{" "}
            </div>
            <h5
              title={
                EmpDetails?.employee?.full_name?.length > 15
                  ? EmpDetails?.employee?.full_name
                  : null
              }
              style={{
                textAlign: "start",
                cursor: "pointer",
                color: "grey",
              }}
            >
              {EmpDetails?.employee?.full_name.length > 15
                ? "  " +
                  EmpDetails?.employee?.full_name.substring(0, 12) +
                  "..."
                : "  " + EmpDetails?.employee?.full_name}
            </h5>
          </div>
          <div className=" d-flex col-md-6 ">
            <div>
              {" "}
              <h5>Gender : &ensp;</h5>{" "}
            </div>
            <h5
              title={
                EmpDetails?.employee?.gender.length > 15
                  ? EmpDetails?.employee?.gender
                  : null
              }
              style={{
                textAlign: "start",
                cursor: "pointer",
                color: "grey",
              }}
            >
              {EmpDetails?.employee?.gender.length > 15
                ? "  " + EmpDetails?.employee?.gender.substring(0, 12) + "..."
                : "  " + EmpDetails?.employee?.gender}
            </h5>

            {/* <h5 style={{ color: 'grey' }}>Name :{EmpDetails.full_name}</h5> */}
            {/* <h5 style={{ color: 'grey' }}>Gender : {EmpDetails.gender}</h5> */}
          </div>
        </div>
        <hr />
        <div className="col-md-12 d-flex">
          <div className="d-flex col-md-6 ">
            <div>
              {" "}
              <h5>Duty : &ensp;</h5>{" "}
            </div>
            <h5
              title={EmpDetails?.employee?.duties_assigned}
              style={{
                textAlign: "start",
                cursor: "pointer",
                color: "grey",
              }}
            >
              {EmpDetails?.employee?.duties_assigned}
            </h5>
          </div>
          <div className=" d-flex col-md-6 ">
            <div>
              {" "}
              <h5>Job status : &ensp;</h5>{" "}
            </div>
            <h5
              title={
                EmpDetails?.employee?.job_status?.name?.length > 15
                  ? EmpDetails?.employee?.job_status?.name
                  : null
              }
              style={{
                textAlign: "start",
                cursor: "pointer",
                color: "grey",
              }}
            >
              {EmpDetails?.employee?.job_status?.name?.length > 15
                ? "  " +
                  EmpDetails?.employee?.job_status?.name.substring(0, 12) +
                  "..."
                : "  " + EmpDetails?.employee?.job_status?.name}
            </h5>
          </div>
        </div>
        <hr />

        <div className="col-md-12 d-flex">
          <div className="d-flex col-md-6 ">
            <div>
              {" "}
              <h5>Mobile : &ensp;</h5>{" "}
            </div>
            <h5
              title={
                EmpDetails?.employee?.mobile_no.length > 15
                  ? EmpDetails?.employee?.mobile_no
                  : null
              }
              style={{
                textAlign: "start",
                cursor: "pointer",
                color: "grey",
              }}
            >
              {EmpDetails?.employee?.mobile_no.length > 15
                ? "  " +
                  EmpDetails?.employee?.mobile_no.substring(0, 12) +
                  "..."
                : "  " + EmpDetails?.employee?.mobile_no}
            </h5>
          </div>
          {/* <div className=" d-flex col-md-6 ">

                                    <div ><h5 >Payment : &ensp;</h5> </div>
                                    <h5 title={EmpDetails.pemployee?.ayment_type.length > 15 ? EmpDetails.payment_type : null} style={{ textAlign: "start", cursor: "pointer", color: 'grey' }}>{EmpDetails.payment_type.length > 15 ? "  " + EmpDetails.payment_type.substring(0, 12) + "..." : "  " + EmpDetails.payment_type}</h5>

                                </div> */}
        </div>

        {/* <div className=" col-md-6 d-flex justify-content-between">
                                <h5 style={{ color: 'grey' }}>Mobile  : {EmpDetails.mobile_no}</h5>
                                <h5 style={{ color: 'grey' }}>Payment : {EmpDetails.payment_type}</h5>

                            </div> */}
        <hr />

        <div className="col-md-12 d-flex">
          {/* <div className="d-flex col-md-6 ">

                                    <div> <h5 >Account Head : &ensp;</h5> </div>
                                    <h5 title={EmpDetails.account_head.length > 25 ? EmpDetails.account_head : null} style={{ textAlign: "start", cursor: "pointer", color: 'grey' }}>{EmpDetails.account_head.length > 25 ? "  " + EmpDetails.account_head.substring(0, 22) + "..." : "  " + EmpDetails.account_head}</h5>
                                </div> */}
          <div className=" d-flex col-md-6 ">
            <div>
              {" "}
              <h5>Address : &ensp;</h5>{" "}
            </div>
            <h5
              title={
                EmpDetails?.employee?.address.length > 25
                  ? EmpDetails?.employee?.address
                  : null
              }
              style={{
                textAlign: "start",
                cursor: "pointer",
                color: "grey",
              }}
            >
              {EmpDetails?.employee?.address.length > 25
                ? "  " + EmpDetails?.employee?.address.substring(0, 22) + "..."
                : "  " + EmpDetails?.employee?.address}
            </h5>
          </div>
        </div>

        {/* <div className=" col-md-6 d-flex justify-content-between">
                                <h5 style={{ color: 'grey' }}>Account Head : {EmpDetails.account_head}</h5>
                                <h5 style={{ color: 'grey' }}>Address: {EmpDetails.address}</h5>

                            </div> */}
        <hr />
      </div>

      <div className="card p-3">
        <h1 className="m-3">Salary details</h1>
        <br />
        <UserDetails
          title="Salary Days"
          value={EmpDetails?.employee?.salary_days}
          title2="Social_security_number"
          value2={EmpDetails?.employee?.social_security_number}
        />
        <UserDetails
          title="Payment type"
          value={EmpDetails?.employee?.payment_type}
          title2="Reg Code"
          value2={EmpDetails?.employee?.reg_code}
        />
      </div>

      <div className="card p-3">
        <h1 className="m-3">GP Fund details</h1>
        <br />
        <UserDetails
          title="ID"
          value={EmpDetails?.employee?.gp_collected_fund?.id}
          title2="Collected Amount"
          value2={EmpDetails?.employee?.gp_collected_fund?.collected_amount}
        />
      </div>

      {/* Salary Allowance */}
      <div className="card p-3">
        <h1 className="m-3">Salary Allowance</h1>
        <br />

        {groupByTwo(allowances).map((pair, index) => (
          <UserDetails
            key={index}
            title={pair[0]?.name || ""}
            value={pair[0]?.value || ""}
            title2={pair[1]?.name ?? "---"}
            value2={pair[1]?.value ?? "---"}
          />
        ))}
      </div>

      {/* Salary Deduction */}
      <div className="card p-3">
        <h1 className="m-3">Salary Deduction</h1>
        <br />

        {groupByTwo(deductions).map((pair, index) => (
          <UserDetails
            key={index}
            title={pair[0]?.name || ""}
            value={pair[0]?.value || ""}
            title2={pair[1]?.name ?? "---"}
            value2={pair[1]?.value ?? "---"}
          />
        ))}
      </div>
    </>
  );
};

export default ViewSalaryDetails;

const UserDetails = ({ title, title2, value, value2 }) => {
  return (
    <>
      <div className="col-md-12 d-flex">
        <div className="d-flex col-md-6 ">
          <h5>{title} : &ensp;</h5>
          <h5 style={{ textAlign: "start", cursor: "pointer", color: "grey" }}>
            {" "}
            {value}
          </h5>
        </div>
        <div className=" d-flex col-md-6 ">
          <h5>{title2} : &ensp;</h5>
          <h5 style={{ textAlign: "start", cursor: "pointer", color: "grey" }}>
            {" "}
            {value2}
          </h5>
        </div>
      </div>

      <hr />
    </>
  );
};
